/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizers_Last_WarningInputs */



/**
* | output |
* | --- |
* | "Cannot remove the last organizer" |
*
* @param {Organizers_Last_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const organizers_last_warning = /** @type {((inputs?: Organizers_Last_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizers_Last_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de retirer le dernier organisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede eliminar el último organizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível remover o último organizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile rimuovere l'ultimo organizzatore")
	return /** @type {LocalizedString} */ ("Cannot remove the last organizer")
});